import { api } from '../../services/api'

const GEOREVERSE_HERE_BATCH_LIMIT = 100

// Get here multiple reverse geocoded coordinates
// Maximum coordinates per request is 100
// `withUserLocations`: a coordinate inside one of the company's user locations is named
// after that location instead of its address, as the single reverse geocode does
export async function batchReverseGeocode (coordinates, { withUserLocations = false } = {}) {
  let allResults = [] // Array to accumulate results
  let batchForSend = []

  try {
    if (coordinates && coordinates.length) {
      for (let i = 0; i <= coordinates.length; i++) {
        batchForSend.push(coordinates[i])

        if ((batchForSend.length / GEOREVERSE_HERE_BATCH_LIMIT) === 1) {
          const response = await api()['satellite-tracking'].post('here-batch-reverse-geocode', {
            coordinates: batchForSend, // Send the current batch
            withUserLocations
          })

          batchForSend = []
          allResults.push(response.data)
        }
        else if (i === coordinates.length - 1 && batchForSend.length) {
          const response = await api()['satellite-tracking'].post('here-batch-reverse-geocode', {
            coordinates: batchForSend, // Send the last remain batch
            withUserLocations
          })

          batchForSend = []
          allResults.push(response.data)
        }
      }

      allResults = allResults.reduce((finalObj, currentItem) => {
        return { ...finalObj, ...currentItem }
      }, {})

      return allResults
    }

    return {}
  }
  catch (exception) {
    console.error('Multiple reverse geocoding exception occurred:', exception)
  }
}
